// API Configuration
// This file centralizes the API base URL for all frontend API calls
// Set REACT_APP_API_URL in your .env file
// For local dev: REACT_APP_API_URL=http://localhost:3001
// For production: REACT_APP_API_URL=https://your-aws-url.elasticbeanstalk.com

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Helper function to build full API URLs
export function getApiUrl(path: string): string {
  // Remove leading slash if present to avoid double slashes
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${API_BASE_URL}/${cleanPath}`;
}

